export const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
